import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import QueryString from 'query-string';

import PatientKioskUserLoginForm from '../../containers/Login/PatientKioskUserLoginForm';
import { patientKioskUserLoginRequest } from '../../redux/modules/auth/auth-middleware';
import { setIsDedicatedWorkflow } from '../../redux/modules/workflow/workflow-action-creator';


class PatientKioskUserLoginPage extends Component {
  constructor(props, context) {
    super(props, context);

    const parsedQueryString = QueryString.parse(this.props.location.search);
    let redirectTo = '/';
    if (parsedQueryString.redirect) {
      redirectTo = parsedQueryString.redirect + '?isAutoRedirect=true';
      Object.keys(parsedQueryString).forEach((param) => {
        if (param !== 'redirect') {
          const value = parsedQueryString[param];
          redirectTo += '&' + param + '=' + value;
        }
      });
    }

    this.state = {
      redirectTo,
    };
  }

  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  handleLogin = (singleSignOnIdentificationId, patientId) => {
    this.props.dispatch(patientKioskUserLoginRequest(
      singleSignOnIdentificationId,
      this.state.redirectTo,
      patientId
    ));
  };

  render() {
    return (
      <div>
        <PatientKioskUserLoginForm handleLogin={this.handleLogin} location={this.props.location} />
      </div>
    );
  }
}

PatientKioskUserLoginPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
};

const mapStateToProps = (state, ownProps) => ({
  token: state.token,
  location: ownProps.location,
});

export default connect(mapStateToProps)(PatientKioskUserLoginPage);